export default __webpack_public_path__ + "static/media/light_placeholder.3fee9a85.jpg";